import { CaseReducer, createSlice, PayloadAction } from "@reduxjs/toolkit";

type initialType = {
  city: string;
  country: string;
  countryCode: string;
  showCalendarSection: boolean;
};

const initialState: initialType = {
  city: "",
  country: "",
  countryCode: "",
  showCalendarSection: false,
};

type appSliceReducer<Payload> = CaseReducer<
  initialType,
  PayloadAction<Payload>
>;

const findLocation: appSliceReducer<{
  city: string;
  country: string;
  countryCode: string;
}> = (state, action) => {
  state.city = action.payload.city;
  state.country = action.payload.country;
  state.countryCode = action.payload.countryCode;
};

const changeShowCalendarSection: appSliceReducer<boolean> = (state, action) => {
  state.showCalendarSection = action.payload;
};

export const appSlice = createSlice({
  initialState,
  name: "app",
  reducers: {
    changeShowCalendarSection,
    findLocation,
  },
});

export default appSlice;
